<ng-container *ngComponentOutlet="params?.rowDetailComponent; injector: detailInjector"></ng-container>
